<template>
  <div>
    <div class="main">
      <div class="bg-div">
        <div class="top-info">
          <img :src="imageUrl + storeInfo.picInfo" class="logo-img"/>
          <div class="name">{{ storeInfo.name }}</div>
          <!--          <img src="../../../resource/img/qqq.png" class="saoma"   @click="scanQRClick"/>&lt;!&ndash;@click="scanewm"&ndash;&gt;-->
        </div>
      </div>
      <div class="btn-div">
        <div class="btn" @click="scanQRClick">
          <img src="../../../resource/img/qqq.png">
          <span>核销</span>
        </div>
        <div class="btn" @click="openFans">
          <img src="../../../resource/img/fafang.png">
          <span>查看粉丝</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'

export default {
  name: 'MerTokerMerIndex',
  data () {
    return {
      user: JSON.parse(localStorage.getItem('user')),
      imageUrl: 'https://files.mbspt.com',
      storeInfo: {},
      urlParam: {},
    }
  },
  created () {
    this.urlParam = this.$route.query
  },
  mounted () {
    this.getData()
    this.getConfig()
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/merchant/api/merchant/merchant-union-store-info/find',
        data: {
          id: this.user.merId
        }
      }).then(res => {
        this.storeInfo = res.data
      })
    },
    getConfig () {
      this.$api.post({
        url: '/merchant/api/activity/merchant-market-extend/find/share/config',
        data: {
          merId: this.urlParam.merId,
          url: encodeURIComponent(location.href.split('#')[0])
        },
        login: false
      }).then(res => {
        wx.config({
          appId: res.data.appId, //APPID
          timestamp: res.data.timestamp, //上面main方法中拿到的时间戳timestamp
          nonceStr: res.data.nonceStr, //上面main方法中拿到的随机数nonceStr
          signature: res.data.signature, //上面main方法中拿到的签名signature
          //需要调用的方法接口
          jsApiList: [
            'scanQRCode',
          ]
        })
        wx.ready(() => {
          wx.checkJsApi({
            jsApiList: ['scanQRCode'],
            success: function (res) {
            }
          })
        })
        wx.error(res => {
          location.reload()
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      })
    },
    scanQRClick () {
      let that = this
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: res => {
          let url = decodeURIComponent(res.resultStr)
          alert(url)
          let params = url.split('&')
          let a = params[2].split('=')
          if (a[1] == 'mrmf_union_use') {
            //商家联盟核销情况
            let order = params[3].split('=')
            let id = order[1]
            if (!this.$util.isArrOrNull(id)) {
              that.unionOrderUse(id)
            }
          }
        }
      })
    },
    unionOrderUse (id) {
      this.$api.post({
        url: '/merchant/api/activity/merchant-union-order-usedetail/check',
        data: {
          id: id
        }
      }).then(res => {
        Toast.success(res.msg)
      })
    },
    openFans(){
      this.$router.push({
        path: '/MerUnionFansList',
        query: {
          merId: this.urlParam.merId
        }
      })
    }
  }
}
</script>

<style scoped>
.main {
  padding: 50px 0vw 0 0vw;
  font-size: 15px;
}

.bg-div {
  width: 100%;
  height: 200px;
  background-image: url("../../../resource/img/Nipic_12106414_20160922174257880038.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  -moz-background-size: 100% 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
}

.top-info {
  display: flex;
  flex-direction: row;
  margin: 3vw;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 10px;
}

.top-info .name {
  flex: 1;
  text-align: left;
  margin-top: 10px;
}

.top-info .logo-img {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  margin-right: 10px;
}

.btn-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: -12vw 3vw 3vw 3vw;
  background: rgba(255, 255, 255, 1);
  border-radius: 10px;
  padding: 10px;
}

.btn-div .btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.btn-div .btn > img {
  width: 40px;
  height: 40px;
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/active/member/MerTokerMerIndex.vue